<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-md-4 col-sm-12 mb-2">Report</h4>
                    <div *ngIf="checkedData.length" class="col-md-8 col-sm-12 d-flex justify-content-end">
                        <div>
                            <button title="Delete selected" class="btn btn-danger" (click)="deleteDialog.show(checkedData)">
                                Delete selected item(s)
                            </button>
                        </div>
                    </div>
                    <div *ngIf="!checkedData.length" class="col-md-8 col-sm-12 d-flex justify-content-end">
                        <div *ngIf="!pageQuery.isSearch">
                            <button title="Filter" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary position-relative" (click)="filterDialog.show()">
                                <i class="material-icons">filter_alt</i>
                                <span *ngIf="filterDialog.hasFilter" class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                                    <span class="visually-hidden">New alerts</span>
                                </span>
                            </button>
                            <button title="Refresh" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary ms-1" (click)="getData()">
                                <i class="material-icons">refresh</i>
                            </button>
                            <button title="Search" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary ms-1" (click)="pageQuery.isSearch=true">
                                <i class="material-icons">search</i>
                            </button>
                            <button title="Download" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary ms-1" (click)="downloadData()">
                                <i class="material-icons">file_download</i>
                            </button>
                            <button title="Delete All Data" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-danger ms-1" (click)="deleteDialog.show()">
                                <i class="material-icons">delete_forever</i>
                            </button>
                        </div>
                        <div *ngIf="pageQuery.isSearch" class="w-100">
                            <div class="input-group has-search">
                                <span class="input-group-text pt-0 pb-0 bg-white border-secondary">
                                    <i class="material-icons">search</i>
                                </span>
                                <input type="search" [appAutoFocus]="true" [(ngModel)]="pageQuery.queryPage.q" (keyup)="pageQuery.searchData($event)" class="form-control border-start-0 ps-1 shadow-none border-secondary bg-light" placeholder="Type & Hit Enter">
                                <button title="Search" class="btn btn-secondary" [attr.disabled]="loading.status ? 'disabled' : null" (click)="pageQuery.changeRoute({q:''});pageQuery.isSearch=false;">
                                    <i class="material-icons">close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="filterDialog.hasFilter" class="d-flex pt-2 align-items-center">
                    <div class="pe-2">
                        <button type="button" title="Clear Filter" (click)="filterDialog.hide()" class="btn btn-sm btn-danger p-0">
                            <i class="material-icons">close</i>
                        </button>
                    </div>
                    <div class="d-flex">
                        <span *ngIf="filterDialog.model.from_date;" class="text-bg-info p-1 rounded text-light me-1">
                            Date: {{filterDialog.model.from_date}} {{filterDialog.model?.from_time}} to {{filterDialog.model?.to_date}} {{filterDialog.model?.to_time}}
                        </span>
                        <span *ngIf="filterDialog.model.quiz_type;" class="text-bg-info p-1 rounded text-light me-1">
                            Quiz Type: {{filterDialog.model.quiz_type}}
                        </span>
                    </div>
                </div>
                <div class="row pt-2">
                    <div class="col-12">
                        <div class="text-center h4 p-3" *ngIf="!data?.data?.length">
                            <div *ngIf="loading.status">
                                <div class="spinner-grow" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <div *ngIf="!loading.status">
                                No data found..
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover" *ngIf="data?.data?.length">
                                <thead>
                                    <tr>
                                        <th class="text-center">
                                            <div class="form-check">
                                                <input class="form-check-input" [checked]="isAllCheckBoxChecked()" (change)="checkAllCheckBox($event)" type="checkbox" name="checkAll" id="checkAll">
                                            </div>
                                        </th>
                                        <th class="text-center">
                                            #
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='date'" [class.desc]="pageQuery.queryPage.order=='-date'" sortable="date" (sort)="onSort($event)">
                                            Date
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='time'" [class.desc]="pageQuery.queryPage.order=='-time'" sortable="time" (sort)="onSort($event)">
                                            Time
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='quiz_name'" [class.desc]="pageQuery.queryPage.order=='-quiz_name'" sortable="quiz_name" (sort)="onSort($event)">
                                            Quiz
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='member.name'" [class.desc]="pageQuery.queryPage.order=='-member.name'" sortable="member.name" (sort)="onSort($event)">
                                            Participant Name
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='member.email'" [class.desc]="pageQuery.queryPage.order=='-member.email'" sortable="member.email" (sort)="onSort($event)">
                                            Email
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='member.phone'" [class.desc]="pageQuery.queryPage.order=='-member.phone'" sortable="member.phone" (sort)="onSort($event)">
                                            Phone
                                        </th>
                                        <th class="text-end" [class.asc]="pageQuery.queryPage.order=='point'" [class.desc]="pageQuery.queryPage.order=='-point'" sortable="point" (sort)="onSort($event)">
                                            Point
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='elapsed_time'" [class.desc]="pageQuery.queryPage.order=='-elapsed_time'" sortable="elapsed_time" (sort)="onSort($event)">
                                            Elapsed Time
                                        </th>
                                        <th class="text-center">
                                            <i class="material-icons">more_vert</i>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of data?.data;let i=index;">
                                        <td class="text-center">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" [checked]="isCheckBoxChecked(item)" (click)="checkCheckBox(item)">
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            {{data.from+i}}
                                        </td>
                                        <td>
                                            {{item.created_at | dateFormat:'DD MMM YYYY'}}
                                        </td>
                                        <td>
                                            {{item.created_at | dateFormat:'HH:mm'}}
                                        </td>
                                        <td nowrap>
                                            {{item.quiz_name}} {{item.quiz_type}}
                                        </td>
                                        <td>
                                            {{item.member?.name}}
                                        </td>
                                        <td>
                                            {{item.member?.email}}
                                        </td>
                                        <td>
                                            {{item.member?.phone}}
                                        </td>
                                        <td class="text-end">
                                            {{item.point}}
                                        </td>
                                        <td>
                                            {{item.elapsed_time}}
                                        </td>
                                        <td class="text-center" nowrap>
                                            <button [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-outline-danger btn-sm" title="Delete" (click)="deleteDialog.show([item.id])">
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="data?.data?.length" class="d-flex justify-content-between row small">
                            <div class="col-md-2 small d-flex flex-nowrap row align-items-center">
                                <div class="col-5 d-flex align-items-center">Limit :</div>
                                <select style="height: 25px;" class="form-select form-select-sm col-6 w-50" [attr.disabled]="loading.status ? 'disabled' : null" [(ngModel)]="pageQuery.queryPage.limit" (change)="pageQuery.changeRoute({limit:pageQuery.queryPage.limit});">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div class="col-md-4 d-flex flex-nowrap align-items-center justify-content-center justify-content-md-end">
                                <div class="text-nowrap">
                                    Total: {{data.total || 0}}
                                </div>
                                <div class="text-nowrap">
                                    <button (click)="pageQuery.changeRoute({page:1});" class="btn btn-sm border-0 m-1 p-1" [attr.disabled]="loading.status || data.current_page===1 || !data.prev_page_url ? 'disabled' : null">
                                        <span class="material-icons">first_page</span>
                                    </button>
                                    <button (click)="pageQuery.changeRoute({page:(data.prev_page_url).split('page=')[1]});" class="btn btn-sm border-0 m-1 p-1" [attr.disabled]="loading.status || data.current_page===1 || !data.prev_page_url ? 'disabled' : null">
                                        <span class="material-icons">navigate_before</span>
                                    </button>
                                    <span>
                                        {{data.current_page || 1}}/{{data.last_page || '&infintie;'}}
                                    </span>
                                    <button (click)="pageQuery.changeRoute({page:(data.next_page_url).split('page=')[1]});" class="btn btn-sm border-0 m-1 p-1" [attr.disabled]="loading.status || !data.next_page_url || pageQuery.queryPage.page===data.last_page ? 'disabled' : null">
                                        <span class="material-icons">navigate_next</span>
                                    </button>
                                    <button (click)="pageQuery.changeRoute({page:data.last_page});" class="btn btn-sm border-0 m-1 p-1" [attr.disabled]="loading.status || !data.next_page_url || pageQuery.queryPage.page===data.last_page || !data.last_page ? 'disabled' : null">
                                        <span class="material-icons">last_page</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #deleteModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Delete</h5>
    </div>
    <div class="modal-body">
        Are you sure want to delete {{deleteDialog.ids?.length?'selected data':'ALL DATA'}}?
    </div>
    <div class="modal-footer d-flex justify-content-between">
        <div>
            <div class="spinner-border text-primary" role="status" *ngIf="deleteDialog.isDeleting && loading.status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="text-end">
            <button type="button" class="btn btn-primary" (click)="modal.close()" [attr.disabled]="loading.status ? 'disabled' : null">Cancel</button>
            &nbsp;
            <button type="button" class="btn btn-danger" (click)="deleteDialog.submit()" [attr.disabled]="loading.status ? 'disabled' : null">
                Delete {{!deleteDialog.ids?.length?'All Data':''}}
            </button>
        </div>
    </div>
</ng-template>


<ng-template #filterModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Filter</h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="row mb-3">
                    <div class="col-md-12">
                        <label class="fw-bold">Date &amp; Time :</label>
                    </div>
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-5">
                                <div class="row">
                                    <div class="col-8">
                                        <input type="date" [(ngModel)]="filterDialog.model.from_date" class="form-control">
                                    </div>
                                    <div class="col-4 ps-0">
                                        <input type="time" [(ngModel)]="filterDialog.model.from_time" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 d-flex justify-content-center align-items-center">To</div>
                            <div class="col-5">
                                <div class="row">
                                    <div class="col-8">
                                        <input type="date" [(ngModel)]="filterDialog.model.to_date" class="form-control">
                                    </div>
                                    <div class="col-4 ps-0">
                                        <input type="time" [(ngModel)]="filterDialog.model.to_time" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12">
                        <label class="fw-bold">Quiz Type :</label>
                    </div>
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-6">
                                <select class="form-select ms-1" [attr.disabled]="loading.status ? 'disabled' : null" [(ngModel)]="filterDialog.model.quiz_type">
                                    <option value="">- Filter -</option>
                                    <option value="WPPSI">WPPSI</option>
                                    <option value="WPPSI|Visual Spatial Index">WPPSI Visual Spatial</option>
                                    <option value="WPPSI|Processing Speed Index">WPPSI Processing Speed</option>
                                    <option value="DCCS">DCCS</option>
                                    <option value="DCCS|Pre-Switch">DCCS Pre-Switch</option>
                                    <option value="DCCS|Post-Switch">DCCS Post-Switch</option>
                                    <option value="DCCS|Border Phase">DCCS Border Phase</option>
                                    <option value="STROOP Test">STROOP Test</option>
                                    <option value="STROOP Test|Congruent">STROOP Test Congruent</option>
                                    <option value="STROOP Test|Incongruent">STROOP Test Incongruent</option>
                                    <option value="CANTAB">CANTAB Test</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-between">
        <div>
            <div class="spinner-border text-primary" role="status" *ngIf="loading.status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="text-end">
            <button type="button" class="btn btn-primary" (click)="filterDialog.hide()" [attr.disabled]="loading.status ? 'disabled' : null">
                {{filterDialog.hasFilter?'Clear Filter':'Cancel'}}
            </button>
            &nbsp;
            <button type="button" class="btn btn-secondary" (click)="filterDialog.submit()" [attr.disabled]="loading.status ? 'disabled' : null">Filter</button>
        </div>
    </div>
</ng-template>
<div class="d-none">
    <div class="modal-lg"></div>
</div>
